import React from "react";
import PropTypes from "prop-types";
import { Input, Button } from "antd";

class OidcDetails extends React.Component {
  static propTypes = {
    clientId: PropTypes.string,
    secret: PropTypes.string,
  };

  copyToClipboard = (value) => {
    navigator.clipboard.writeText(value).catch((err) => {
      console.error("Failed to copy: ", err);
    });
  };

  renderField = (label, value) => (
    <div style={{ marginBottom: 16 }}>
      <div style={{ display: "flex", gap: 8, marginTop: 4, width: "100%" }}>
        <Input
          addonBefore={label}
          value={value}
          readOnly
          style={{ flexGrow: 1 }}
        />
        <Button onClick={() => this.copyToClipboard(value)}>Copy</Button>
      </div>
    </div>
  );

  render() {
    const { clientId, secret } = this.props;

    return (
      <>
        {clientId && this.renderField("Client ID", clientId)}
        {secret && this.renderField("Client Secret", secret)}
      </>
    );
  }
}

export default OidcDetails;
